

import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/information";
const informationState = namespace("Information");

import { supremeCourtCaseJsonDataInfoType, supremeCourtOrdersJsonInfoType } from '@/types/Information/json';

@Component
export default class Form1SearchOrderDetails extends Vue {

    @informationState.State
    public supremeCourtCaseJson: supremeCourtCaseJsonDataInfoType;

    @informationState.Action
    public UpdateSupremeCourtCaseJson!: (newSupremeCourtCaseJson: supremeCourtCaseJsonDataInfoType) => void

    @informationState.Action
    public UpdateSupremeCourtOrderJson!: (newSupremeCourtOrderJson: supremeCourtOrdersJsonInfoType) => void

    dataReady = false;
    orderList: supremeCourtOrdersJsonInfoType[] = [];

    orderFields = [
              
        {
            key: "judgeDisplayName",
            label: "Name of Judge",
            sortable: false,
            tdClass:'align-middle'
        },
        {
            key: "orderDate",
            label: "Date of Order",
            sortable: true,
            tdClass:'align-middle'
        },
        {
            key: "appealSubmissionDeadline",
            label: "Deadline to File and Serve",
            sortable: false,
            tdClass:'align-middle'
        },        
        {
            key: "action",
            label: "",
            sortable: false,
            tdClass:'align-middle'
        }
    ];

    mounted(){
        this.dataReady = false;
        Vue.nextTick().then(() => { 
            this.extractCaseOrders();
        });
    }

    public extractCaseOrders(){

        this.UpdateSupremeCourtOrderJson(null);        
        this.orderList = [];
        if (this.supremeCourtCaseJson?.orders){
            for (const order of this.supremeCourtCaseJson?.orders){            
                order.judgeDisplayName = order.honorificTitle + ' ' + order.judgeSurname;            
                this.orderList.push(order)
            }
        }       
        this.dataReady = true;
    }

    public selectOrder(selectedOrder: supremeCourtOrdersJsonInfoType){
        const caseInfo = this.supremeCourtCaseJson
        const url = '/file-detail/parties/'+ caseInfo.fileId; 
        this.dataReady = false;
        this.$http.get(url)
        .then(res => {            
            if(res.data){ 
                caseInfo.parties = res.data
            }

            this.UpdateSupremeCourtCaseJson(caseInfo);
            this.UpdateSupremeCourtOrderJson(selectedOrder);
            this.dataReady = true;
            this.$emit('selectOrder');
            
        }, error =>{
            caseInfo.parties =[]
            this.UpdateSupremeCourtCaseJson(caseInfo);
            this.UpdateSupremeCourtOrderJson(selectedOrder);
            this.dataReady = true;
            this.$emit('selectOrder');
        })        
    }
    
}
